import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";
import * as zIndexes from "zIndexes.module.scss";

const useStyles = makeStyles((theme) => ({
  content: {
    display: "flex",
    flexDirection: "column",
    position: "absolute",
    justifyContent: "flex-start",
    background: theme.palette.white,
    zIndex: zIndexes.muiModalZIndex,
    right: theme.spacing(2),
    bottom: theme.spacing(2),
    width: "910px",
    height: "450px",
    borderRadius: "5px",
    padding: `${theme.spacing(1.25)} ${theme.spacing(1)} ${theme.spacing(
      2.25,
    )}`,
    boxShadow: "2px 4px 20px rgb(0 0 0 / 10%)",
  },
  settings: {
    gap: theme.spacing(1.25),
    margin: `0 ${theme.spacing(2.5)}`,
    alignItems: "center",
  },
  select: {
    "& .MuiFormControl-root": {
      width: "200px",
    },
  },
  grid: {
    marginTop: theme.spacing(1),
    width: "100%",
    overflow: "auto",
  },
  header: {
    width: "100%",
    cursor: "move",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  headerContent: {
    width: "100%",
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
  },
  title: {
    color: theme.palette.blue.dark,
    marginLeft: theme.spacing(1),
  },
  container: {
    position: "relative",
    flexGrow: 1,
    width: "100%",
    height: "calc(100% - 50px)",
  },
  leftPanel: {
    display: "flex",
    flexDirection: "column",
    width: "250px",
    flexShrink: 0,
    background: "white",
    marginTop: "8px",
  },
  actions: {
    display: "flex",
    gap: "10px",
  },
}));

export default useStyles;
